// The dot beside "Live on Zoom with Adam" and "Replay", on Free webinars' cards and a replay's own page:
// the colour of what the webinar sells, gold when it sells nothing. Property Cashflow For Life's light
// green has a ring, as the board draws it. A dot only, never carrying words.
import { accentKey } from '../library/model.js'
import { productTypeByName } from '../config/products.js'

export function Dot({ look, name }) {
  const key = look ? accentKey(look, productTypeByName(name)) : 'master'
  return <span className={`dot dot--${key}${key === 'pcfl' ? ' dot--ring' : ''}`} />
}
